module.exports = __webpack_public_path__ + "img/baby-carriage.b411152c.svg";